import React, { useState } from "react";
import "./style.scss";
import { useGetSet } from "react-use";
import cardItemImg1 from "assets/landing/block-services-1.webp";
import cardItemImg2 from "assets/landing/block-services-2.webp";
import cardItemImg3 from "assets/landing/block-services-3.webp";
import cardItemImg4 from "assets/landing/block-services-4.webp";
import cardItemImg5 from "assets/landing/block-services-5.webp";
import { Autoplay } from "swiper";
import { SwiperProps } from "swiper/react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Swiper as SwiperClass } from "swiper/types";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";

export default function BlockServices() {
  const { t } = useTranslation();

  const items = [
    {
      title: t("Technical Guidance"),
      description: t("block_services__description_3"),
      img: cardItemImg3,
      icon: "bar-chart",
    },
    {
      title: t("CV & Cover Letter"),
      description: t("block_services__description_1"),
      img: cardItemImg1,
      icon: "file-text",
    },
    {
      title: t("Behavioural & Fit"),
      description: t("block_services__description_2"),
      img: cardItemImg2,
      icon: "message-circle",
    },
    {
      title: t("Industry Insight"),
      description: t("block_services__description_4"),
      img: cardItemImg4,
      icon: "trending-up",
    },
    {
      title: t("Case Interview"),
      description: t("block_services__description_5"),
      img: cardItemImg5,
      icon: "mic",
    },
  ];

  const [getActiveIndex, setActiveIndex] = useGetSet<number>(0);
  const [swiper, setSwiper] = useState<SwiperClass>();

  const onClick = (index: number) => {
    swiper?.slideTo(index);
  };

  const swiperProps: SwiperProps = {
    modules: [Autoplay],
    spaceBetween: 30,
    speed: 500,
    onSwiper: (instance) => setSwiper(instance),
    onSlideChange: () => {
      setActiveIndex(swiper?.activeIndex || 0);
    },
    onBreakpoint: (swiper) => {
      window.innerWidth < 768 ? swiper.autoplay.stop() : swiper.autoplay.start();
    },
    breakpoints: {
      "768": {
        autoplay: {
          delay: 30000,
          disableOnInteraction: false,
        },
      },
    },
  };

  return (
    <div className="block-services">
      <h2 className="block-services__title h2 mb-4 text-center mx-auto">
        {t("A tailored approach built for results")}
      </h2>
      <div className="block-services__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t(
          "We equip students to perform with confidence and help universities achieve measurable gains in employability. Our insider-led, finance-specific approach complements — not competes with — existing career services."
        )}
      </div>

      <div className="block-services__wrapper box-shadow pa-6">
        <div className="block-services__buttons d-center gap-2">
          {items.map((item, index) => (
            <BaseButton
              key={index}
              className={"block-services__button" + (getActiveIndex() === index ? " __active fw-bold" : "")}
              gradient={getActiveIndex() === index}
              borderless={getActiveIndex() !== index}
              large
              onClick={() => onClick(index)}
            >
              <BaseIcon className="f-shrink-0 mr-2">{item.icon}</BaseIcon>
              {item.title}
            </BaseButton>
          ))}
        </div>

        <Swiper {...swiperProps}>
          {items.map((item, i) => (
            <SwiperSlide className="block-services__item" key={i}>
              <div className="f-grow">
                <div className="caption-1 fw-bold mb-4">{item.title}</div>
                <div className="block-services__item-description body-1">{item.description}</div>
              </div>
              <div className="block-services__item-image" style={{ backgroundImage: `url(${item.img})` }}></div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
